var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12"},[_c('ul',{staticClass:"nav nav-pills compare-view"},[_c('li',{staticClass:"active",attrs:{"data-value":"all"}},[_c('a',{attrs:{"href":"#"}},[_vm._v("All Fields")])]),_vm._v(" "),_c('li',{attrs:{"data-value":"different"}},[_c('a',{attrs:{"href":"#"}},[_vm._v("Differences Only")])])])])
}]

export { render, staticRenderFns }